/**
 * 글자 크기 상수/헬퍼 (호환) — kingdoo-editor styles/FontSizeStyle.tsx의 export 패리티.
 */
export const FONT_SIZE_PRESETS = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '28px',
];
export const FONT_SIZE_MIN = 8;
export const FONT_SIZE_MAX = 96;
export const FONT_SIZE_DEFAULT_PX = 14;
export const FONT_SIZE_STEP = 1;

export function parseFontSizePx(size) {
  const m = String(size == null ? '' : size).match(/^([\d.]+)/);
  const n = m ? parseFloat(m[1]) : NaN;
  return Number.isFinite(n) && n > 0 ? n : FONT_SIZE_DEFAULT_PX;
}
export function clampFontSizePx(px) {
  return Math.round(Math.max(FONT_SIZE_MIN, Math.min(FONT_SIZE_MAX, px)));
}
export function toFontSizeValue(px) {
  return clampFontSizePx(px) + 'px';
}
